// src/lib/services.js
const services = [
  {
    title: 'MAD Deluxe Full Detail',
    slug: 'mad-deluxe-full-detail-2',
    bestFor:
      'Ideal for first-time detailing, vehicles with surface contaminants, or clients wanting long-lasting protection with a deep clean.',
    category: 'car-detailing',
    serviceType: 'Full Detail',
    exteriorServiceList: [
      'Frictionless Wash using deionized water to remove road traffic film (RTF)',
      'Chemical Decontamination with iron remover',
      'Comprehensive Wheel Well Cleaning',
      'Tire & Wheel Detailing: Clean, dress, and shine',
      'Clay Towel Wash for Mechanical Decontamination',
      'Neutralizing Hand Wash using deionized water and pH-neutral soap',
      'Special Attention to Badges, Grilles, Cracks, and Crevices',
      'Paint Enhancement Polish: Improves gloss and removes light surface imperfections',
      'MAD HyperSlick Ceramic Spray Coating: Up to 9 months of protection',
      'Ceramic Windshield Coating',
      'Exterior Window Cleaning and Shine',
      'Engine Bay Detail: Deep cleaning, degreasing, and conditioning',
    ],
    interiorServiceList: [
      'Interior Cleaning of All Surfaces',
      'Thorough Interior Vacuum, Including Trunk',
      'Vent Cleaning for improved air circulation',
      'Headliner Spot Clean for light stain removal',
      'Floor Mat and Carpet Refresh',
      'Upholstery & Leather Refresh: Light cleaning and conditioning',
      'UV Protectant Interior Dressing',
      'Weather Stripping Cleaned',
      'Door Jambs Fully Cleaned',
      'Air Freshener',
    ],
    recommendedTimeframe: 'Every 6 to 12 months.',
    description:
      'Our premium full detail designed to remove surface contaminants, restore shine, and protect your vehicle inside and out. Includes engine bay cleaning and ceramic windshield coating.',
    imageSrc: 'mad-web-app/serv-images/mad-deluxe-full-detail-2',
    servicePricing: [299, 339, 379, 419],
    price: 'Starting at $299',
  },

  {
    title: 'MAD Refresh Full Detail',
    slug: 'mad-refresh-full-detail',
    bestFor:
      'Ideal for vehicles that need a full detail without extensive correction. Great for seasonal resets, ride-share vehicles, or routine reconditioning.',
    category: 'car-detailing',
    serviceType: 'Full Detail',
    exteriorServiceList: [
      'Hand Wash (Spot-Free)',
      'Comprehensive Wheel Well Cleaning',
      'Tire & Wheel Cleaning, Dressing, and Shine',
      'Special Attention to Badges, Grilles, Cracks, and Crevices',
      'Exterior Glass Cleaned and Shined',
      'MAD HyperSlick Ceramic Spray Coating: Up to 9 months of protection',
      'Weather Stripping Cleaned',
      'Door Jambs Fully Cleaned',
    ],
    interiorServiceList: [
      'Interior Cleaning of All Surfaces',
      'Thorough Vacuum (Including Trunk)',
      'Vent Cleaning for Air Circulation',
      'Spot Headliner Cleaning (Light Spots Only)',
      'Floor Mat and Carpet Refresh',
      'Upholstery & Leather Refresh: Light Cleaning and Conditioning',
      'UV Protectant Interior Dressing',
      'Air Freshener',
    ],
    recommendedTimeframe: 'Every 3 to 6 months.',
    description:
      'Our mid-tier full detail. A complete interior and exterior refresh for vehicles needing more than just a basic cleanup. Includes ceramic spray coating for long-lasting protection.',
    imageSrc: 'mad-web-app/serv-images/mad-refresh-full-detail',
    servicePricing: [199, 229, 259, 289],
    price: 'Starting at $199',
  },
  {
    title: 'MAD Express Clean',
    slug: 'mad-express-clean',
    bestFor:
      'Ideal for regular upkeep between full details or a quick cleanup to make your vehicle presentable again. Not a deep clean.',
    category: 'car-detailing',
    serviceType: 'Full Detail',
    exteriorServiceList: [
      'Hand Wash (Spot-Free)',
      'Wheel, Tire, and Wheel Well Cleaning',
      'Tire Dressing',
      'Exterior Glass Cleaned',
      'Door Jambs Wiped Down',
    ],
    interiorServiceList: [
      'Standard Vacuum (Floors and Seats Only)',
      'Light Wipe Down of Dash, Console, and Door Panels',
      'Interior Glass Cleaned',
      'Optional Air Freshener Spritz',
    ],
    recommendedTimeframe: 'Every 2 to 4 weeks for regular maintenance.',
    description:
      'Our most basic surface cleaning service. A quick hand wash and interior wipe-down for light maintenance. No stain removal or deep cleaning included.',
    imageSrc: 'mad-web-app/serv-images/mad-express-clean',
    servicePricing: [99, 119, 139, 159],
    price: 'Starting at $99',
  },
  {
    title: 'Exterior Wash & Protect',
    slug: 'exterior-wash-protect', // Generated from the title if desired
    bestFor: 'New or well-maintained vehicles that are regularly cleaned.',
    category: 'car-detailing',
    serviceType: 'Exterior Only', // Customize this label as needed
    exteriorServiceList: [
      'Frictionless Wash: Removes surface contaminants like road traffic film.',
      'Wheel Well & Barrel Cleaning: Thorough attention to wheels and wheel wells.',
      'Tire & Wheel Detailing: Clean, dress, and shine tires for a polished look.',
      'Hand Wash: Gentle wash with deionized water to prevent water spots.',
      'Detailing Badges & Crevices: Removes dirt from hard-to-reach areas.',
      'Ceramic Spray Coating: Up to 9 months of hydrophobic protection.',
      'Window Cleaning: Spotless, crystal-clear glass.',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Every 2 to 4 weeks.',
    description:
      'A maintenance-focused exterior wash designed for well-maintained vehicles that need a thorough, spot-free clean with lasting protection.',
    imageSrc: 'mad-web-app/serv-images/exterior-wash-protect',
    servicePricing: [100, 125, 150, 175],
    price: 'Starting at $100',
  },
  {
    title: 'Exterior Decon & Protect',
    slug: 'exterior-decon-protect', // Generated from the title if desired
    bestFor: 'First-time detailing or vehicles needing decontamination.',
    category: 'car-detailing',
    serviceType: 'Exterior Only', // You can adjust this label as needed
    exteriorServiceList: [
      'Frictionless Wash: Removes surface contaminants like road traffic film.',
      'Iron Remover: Breaks down bonded iron particles and fallout.',
      'Clay Towel Decontamination: Removes embedded contaminants for a smooth surface.',
      'Neutralizing Wash: Final wash to balance pH and remove residue.',
      'Ceramic Spray Coating: Up to 9 months of hydrophobic protection.',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Every 3 to 6 months.',
    description:
      'Designed for vehicles needing decontamination and long-term protection, this service removes bonded contaminants and prepares the surface.',
    imageSrc: 'mad-web-app/serv-images/exterior-decon-protect',
    servicePricing: [175, 200, 250, 300],
    price: 'Starting at $175',
  },

  {
    title: 'Exterior Clay & Polish',
    slug: 'exterior-clay-polish', // Generated from the title if desired
    bestFor: 'Vehicles that have never been detailed or are losing shine.',
    category: 'car-detailing',
    serviceType: 'Exterior Only', // You can adjust this label if needed
    exteriorServiceList: [
      'Frictionless Wash',
      'Iron Remover Treatment',
      'Clay Towel Wash for Mechanical Decontamination',
      'Paint Enhancement Polish (up to 30% correction)',
      'Ceramic Spray Coating (9 months protection)',
      'Wheel & Tire Detailing',
      'Window Cleaning',
    ],
    interiorServiceList: [], // No interior services for an exterior-only service
    recommendedTimeframe: 'Every 6 to 12 months.',
    description:
      'A premium exterior detailing service including full decontamination and a paint enhancement polish to restore gloss and correct minor imperfections.',
    imageSrc: 'mad-web-app/serv-images/exterior-clay-polish',
    servicePricing: [250, 300, 350, 400],
    price: 'Starting at $250',
  },
  {
    title: 'Full Interior Detail',
    slug: 'full-interior-detail', // Generated from the title if desired
    bestFor: "Vehicles that haven't had an interior detail in 6+ months.",
    category: 'car-detailing',
    serviceType: 'Interior Only', // Adjust this label if needed
    exteriorServiceList: [], // No exterior services for an interior-only service
    interiorServiceList: [
      'Interior Steam Cleaning of all Surfaces',
      'Interior Vacuum & Trunk Cleaning',
      'Vent Cleaning',
      'Headliner Spot Clean',
      'Floor Mat & Carpet Refresh',
      'Upholstery & Leather Refresh',
      'UV Protectant Interior Dressing',
      'Weather Stripping Cleaned',
      'Door Jambs Fully Cleaned (If paired with an exterior wash)',
    ],
    recommendedTimeframe: 'Every 4 to 6 months.',
    description:
      'Deep cleaning for vehicles needing an interior refresh. Removes dirt, dust, and minor stains for a fresh cabin.',
    imageSrc: 'mad-web-app/serv-images/full-interior-detail',
    servicePricing: [125, 175, 225, 275],
    price: 'Starting at $125',
  },

  {
    title: 'Total Interior Detail',
    slug: 'total-interior-detail', // Generated from the title if desired
    bestFor:
      'Vehicles with heavy stains, odors, or that have never had a full interior detail.',
    category: 'car-detailing',
    serviceType: 'Interior Only', // Adjust this label if needed
    exteriorServiceList: [], // No exterior services for an interior-only service
    interiorServiceList: [
      'Interior Steam Cleaning of all Surfaces',
      'Interior Vacuum & Trunk Cleaning',
      'Vent Cleaning',
      'Full Headliner Clean',
      'Enzyme Cleaner and Steam Treatment',
      'Floor Mat & Carpet Shampoo and Steam',
      'Upholstery Shampoo and Steam',
      'Leather Steam and Conditioning',
      'UV Protectant Interior Dressing',
      'Weather Stripping Cleaned',
      'Door Jambs Fully Cleaned & Protected (If paired with an exterior wash)',
    ],
    recommendedTimeframe: 'Every 6 to 12 months.',
    description:
      'Deep cleaning and sanitization for heavily soiled interiors with stains and odors.',
    imageSrc: 'mad-web-app/serv-images/total-interior-detail',
    servicePricing: [275, 325, 375, 425],
    price: 'Starting at $275',
  },
  {
    exteriorServiceList: [
      'Comprehensive Wash, Decontamination, and Prep',
      "Paint Enhancement Polish: Improves the overall appearance of your vehicle's paint by removing light surface imperfections, such as minor swirl marks and oxidation, enhancing gloss and clarity.",
      'Installation of MAD Signature Ceramic Coating: Provides a super slick, glossy, and ultra-durable protective layer on your vehicle’s paint and body, significantly improving gloss retention.',
      'Enhanced Hydrophobic Properties: Ensures water and dirt repel effortlessly, keeping your vehicle cleaner for longer.',
      'Chemical and Scratch Resistance: Protects your vehicle from chemical stains and minor scratches, maintaining its pristine condition.',
      'UV and Chemical Resistance: Shields your vehicle from harmful UV rays and chemical stains, ensuring long-lasting protection.',
    ],
    bestFor:
      'Car owners seeking premium, lifetime protection and unmatched gloss for their vehicles.',
    recommendedTimeframe: '10+ years',
    category: 'ceramic-coating',
    serviceType: 'Exterior Only',
    additionalInfo: [
      'Free maintenance wash within 30 days following application',
      'See Installer for warranty information',
    ],
    benefits: [
      'Unmatched Hardness: Shields your vehicle from scratches, dings, and other physical damage.',
      'Superior Hydrophobic Properties: Keeps your vehicle cleaner for longer by repelling water and dirt effortlessly.',
      'Lifetime Warranty: Backed by a lifetime warranty for ultimate peace of mind.',
    ],
    brand: 'max',
    dateCreated: '2025-02-15T04:50:09.413Z',
    description:
      'Application of SystemX Max G+ to paint, body, headlights/tail Lights',
    imagePosition: 'left',
    imageSrc: 'mad-web-app/serv-images/mad-signature-ceramic-coating',
    includes: 'Includes wash, decontamination, and prep',
    servicePricing: [1495, 1695, 1895, 2095],
    price: 'Starting at $1495',
    slug: 'mad-signature-ceramic-coating',
    subtitle: 'Ultimate Protection and Gloss – Lifetime Warranty',
    title: 'MAD Signature Ceramic Coating',
  },
  {
    exteriorServiceList: [
      'Comprehensive Wash, Decontamination, and Prep',
      "Paint Enhancement Polish: Improves the overall appearance of your vehicle's paint by removing light surface imperfections, such as minor swirl marks and oxidation, enhancing gloss and clarity.",
      'Installation of MAD Elite Ceramic Coating: Provides superior chemical resistance and a slick surface, making cleaning easy and keeping your vehicle looking new.',
      'Enhanced Hydrophobic Properties: Ensures water and dirt repel effortlessly, keeping your vehicle cleaner for longer.',
      'UV and Oxidation Protection: Prevents fading and oxidation, maintaining your car’s vibrant look.',
      'Chemical and Scratch Resistance: Protects your vehicle from chemical stains and minor scratches, maintaining its pristine condition.',
    ],
    bestFor:
      'Car owners seeking long-lasting, superior protection and a sleek, easy-to-clean finish.',
    recommendedTimeframe: '6 years.',
    category: 'ceramic-coating',
    serviceType: 'Exterior Only',
    additionalInfo: [
      'Free Maintenance Wash within the First 30 Days After Installation',
      'See Installer for warranty information',
    ],
    benefits: [
      'Superior Chemical Resistance: Shields against harsh chemicals and environmental contaminants.',
      'Slick Surface: Makes cleaning easy by allowing dirt and contaminants to slide off effortlessly.',
      '6-Year Warranty: Supported by a 6-year warranty for long-term protection.',
    ],
    brand: 'pro',
    dateCreated: '2025-02-15T04:39:13.324Z',
    description:
      'Application of SystemX Pro+ to paint, body, headlights/tail Lights',
    imagePosition: 'right',
    imageSrc: 'mad-web-app/serv-images/mad-elite-ceramic-coating',
    includes: 'includes wash, decontamination, and prep',
    servicePricing: [1095, 1195, 1295, 1495],
    price: 'Starting at $1095',
    slug: 'mad-elite-ceramic-coating',
    subtitle: 'Professional Grade Coating – 6-Year Warranty',
    title: 'MAD Elite Ceramic Coating',
  },
  {
    exteriorServiceList: [
      'Comprehensive Wash, Decontamination, and Prep',
      "Paint Enhancement Polish: Improves the overall appearance of your vehicle's paint by removing light surface imperfections, such as minor swirl marks and oxidation, enhancing gloss and clarity.",
      'Installation of MAD Classic Ceramic Coating: Enhances your vehicle’s clarity and shine, providing essential protection for 2-3 years.',
      'Enhanced Hydrophobic Effects: Keeps your vehicle cleaner by repelling water, reducing the need for frequent washes.',
      'Chemical and UV Resistance: Protects your vehicle’s paint from harmful chemicals and UV rays, ensuring lasting beauty.',
      'Gloss Enhancement: Boosts your vehicle’s shine, making it look vibrant and well-maintained.',
    ],
    bestFor:
      'Car owners who want to maintain a vibrant, clean look with cost-effective, low-maintenance protection for 2-3 years.',
    recommendedTimeframe: '2-3 years.',
    category: 'ceramic-coating',
    serviceType: 'Exterior Only',
    additionalInfo: [
      'Expert installation ensures optimal protection.',
      'Pre-application vehicle wash included.',
    ],
    // Key benefits of the service
    benefits: [
      'Enhanced Clarity: Maintains the clarity and vibrancy of your car’s paint.',
      'Smooth',
      'Silky Finish: Resists dirt and grime',
      'making your car easier to clean and maintain',
      'No Warranty: Offers cost-effective coverage with 2-3 year longevity.',
    ],
    brand: 'crystal',
    dateCreated: '2025-02-15T04:54:14.122Z',
    description:
      'Application of SystemX Crystal+ to paint, body, headlights/tail Lights',
    imagePosition: 'left',
    imageSrc: 'mad-web-app/serv-images/mad-classic-ceramic-coating',
    includes: 'includes wash, decontamination, and prep',
    servicePricing: [895, 995, 1095, 1195],
    price: 'Starting at $895',
    slug: 'mad-classic-ceramic-coating',
    subtitle: 'Crystal Clear Protection – 2-3 Year Longevity, No Warranty',
    title: 'MAD Classic Ceramic Coating',
  },
  {
    title: 'Ceramic Window Tint',
    slug: 'ceramic-window-tint',
    bestFor:
      'Ideal for car owners seeking superior UV protection, reduced heat and glare, and enhanced vehicle privacy without signal interference.',
    category: 'window-tint',
    serviceType: 'Ceramic Tinting',
    exteriorServiceList: [
      'Window tint applied to all windows, excluding the windshield and sunroof.',
      'Premium dual-layer ceramic heat-blocking film',
      'Up to 88% IR Rejection',
      '99% UV Protection',
      'Variety of shades to choose from (20%, 35%, 50%, 70%)',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in one day.',
    description:
      'Ceramic tint offers superior protection and comfort by blocking up to 99% of UV rays and significantly reducing heat and glare. Unlike traditional tints, it does not interfere with electronic signals, ensuring clear reception for your devices. This premium tint maintains the appearance and privacy of your vehicle while enhancing its overall performance and longevity.',
    imageSrc: 'mad-web-app/serv-images/standard-window-tint',
    servicePricing: [375, 425, 475, 550],
    price: 'Starting at $375',
  },
  {
    title: 'Traditional Window Tint',
    slug: 'traditional-window-tint',
    bestFor:
      'Ideal for car owners looking for an affordable yet reliable window tint solution that offers excellent UV protection and enhanced comfort.',
    category: 'window-tint',
    serviceType: 'Traditional Tinting',
    exteriorServiceList: [
      'Window tint applied to all glass except windshield (sunroof not included)',
      'Entry Level dual-layer dyed carbon film',
      '99% UV Protection',
      'A variety of shades to choose from (5%, 20%, 35%)',
      'Service completed in one day',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in one day.',
    description:
      "Our Traditional Tint package features the Vintage Series from Solar FX, offering exceptional value and protection for your vehicle. This entry-level dual-layer dyed carbon film provides excellent UV protection and a variety of shade options, enhancing your vehicle's appearance and comfort.",
    imageSrc: 'mad-web-app/serv-images/standard-window-tint',
    servicePricing: [175, 225, 275, 350],
    price: 'Starting at $175',
  },
  {
    title: 'Front Windshield Ceramic Tint',
    slug: 'front-windshield-ceramic-tint',
    bestFor:
      'Ideal for car owners seeking enhanced comfort and heat reduction on their front windshield while meeting TN legal requirements.',
    category: 'window-tint',
    serviceType: 'Windshield Tinting',
    exteriorServiceList: [
      'Front windshield tint application',
      'Premium ceramic tint material',
      'Shade options: 50%, 70%',
      'TN law compliant with over 70% VLT requirement',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in one day.',
    description:
      'Add more comfort and heat reduction with tint on your front windshield. Under TN law, you must allow for more than 70% of light (VLT) for any tint installed on a windshield.',
    imageSrc: 'mad-web-app/serv-images/windshield-tint',
    servicePricing: [175, 175, 175, 175],
    price: '$175',
  },
  {
    title: 'Front Two Windows Tint',
    slug: 'front-two-windows-tint',
    bestFor:
      'Ideal for drivers seeking enhanced privacy, reduced heat, and flexible tint options for their front windows.',
    category: 'window-tint',
    serviceType: 'Front 2 Window Tinting',
    exteriorServiceList: [
      'Tinting for two roll-down windows',
      'Available in your preferred shade',
      'Option for Ceramic film to maximize heat rejection and privacy',
      'Option for Traditional film available',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in one day.',
    description:
      'This package offers tinting for two roll-down windows in your preferred shade, available in either Ceramic or Traditional Film options. Opting for Ceramic film maximizes heat rejection, significantly reducing the workload on your air conditioning system, while also providing enhanced privacy and robust protection against UVA and UVB rays.',
    imageSrc: 'mad-web-app/serv-images/front-2-windows',
    servicePricing: [100, 100, 100, 100],
    price: '$100',
  },
  {
    title: 'Front Windshield Strip',
    slug: 'front-windshield-strip',
    bestFor:
      'Ideal for car owners looking to add a sleek accent to their windshield while providing additional sun protection.',
    category: 'window-tint',
    serviceType: 'Windshield Strip',
    exteriorServiceList: [
      'Windshield strip applied to the top 4-6 inches of the windshield',
      'Shade options: 5%',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in one day.',
    description:
      "Enhance your vehicle's style and reduce glare with our precise windshield strip application, featuring a 5% shade that adds an elegant touch to your car.",
    imageSrc: 'mad-web-app/serv-images/windshield-strip',
    servicePricing: [60],
    price: 'Starting at $60',
  },
  {
    title: 'Exterior Clay & Correct - Level 1',
    slug: 'exterior-clay-correct-level-1',
    bestFor:
      'Ideal for car owners seeking enhanced glossiness, protection, and a quick turnaround for essential paint correction and ceramic coating.',
    category: 'paint-correction',
    serviceType: 'Exterior Clay & Correct - Level 1',
    exteriorServiceList: [
      'Thorough Exterior Spot Free Car Wash',
      'Full Decontamination Prep',
      'Advanced Paint Correction: Achieves 50%-60% correction, diminishing swirling and light scratches.',
      'MAD HyperSlick Ceramic Spray Coating: Provides up to 9 months of hyper gloss, protection, and hydrophobic properties.',
      'Detail and Shine for Tires and Wheels',
      'Exterior Window Cleaning and Shine',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in one day.',
    description:
      'Achieve a substantial improvement in glossiness with our 1-year ceramic coating. The Exterior Clay & Correct - Level 1 service provides essential protection and shine, ensuring your vehicle looks its best with a quick 1-day turnaround.',
    imageSrc: 'mad-web-app/foto-images/foto-image-04',
    servicePricing: [500, 600, 700, 800],
    price: 'Starting at $500',
  },
  {
    title: 'Exterior Clay & Correct - Level 2',
    slug: 'exterior-clay-correct-level-2',
    bestFor:
      'Ideal for car owners seeking the highest level of paint correction and long-lasting protection with a premium ceramic coating solution.',
    category: 'paint-correction',
    serviceType: 'Exterior Clay & Correct - Level 2',
    exteriorServiceList: [
      'Thorough Exterior Spot Free Car Wash',
      'Full Decontamination Prep',
      'Premium Paint Correction: Corrects about 60%-80% of paint imperfections, providing a substantial improvement and a near-perfect finish.',
      'MAD HyperSlick Ceramic Spray Coating: Provides up to 9 months of hyper gloss, protection, and hydrophobic properties.',
      'Detail and Shine for Tires and Wheels',
      'Exterior Window Cleaning and Shine',
    ],
    interiorServiceList: [],
    recommendedTimeframe: 'Completed in 2 days.',
    description:
      'Achieve a remarkable enhancement in glossiness with our premium 1-year ceramic coating. The Exterior Clay & Correct - Level 2 service effectively diminishes surface imperfections while providing long-lasting protection with a 2-day turnaround.',
    imageSrc: 'mad-web-app/serv-images/exterior-clay-correct-level-2',
    servicePricing: [800, 1000, 1200, 1400],
    price: 'Starting at $800',
  },
];

// Function to get all services by category
export const getAllByCategory = (category) => {
  return services.filter((service) => service.category === category);
};

// Function to get all services by service type
export const getAllByServiceType = (serviceType) => {
  return services.filter((service) => service.serviceType === serviceType);
};

// Function to get a service by slug
export const getBySlug = (slug) => {
  return services.find((service) => service.slug === slug);
};

// Function to get all services
export const getAllServices = () => {
  return services;
};

export default services;
